import React from 'react';
import ReactDOM from 'react-dom';

// Styles & Assets
import styles from './ToastsContainer.module.css';

// Components
import Toast from '../../UI/Toast/Toast';

// Interface
import { IToast } from '../../../interfaces/Toast';
interface Props {
    toasts: IToast[]
}

const ToastsContainer: React.FC<Props> = ({ toasts }) => {
    return (
        ReactDOM.createPortal(
            <div className={styles.toastsContainer}>
                {toasts.map(toast =>
                    <Toast key={toast.id} {...toast} />
                )}
            </div>
            , document.getElementById('toast-msg') as HTMLElement)
    );
};

export default ToastsContainer;